export const orderType: Record<"GENERAL_ORDER" | "REPLENISH_ORDER", number> = {
  GENERAL_ORDER: 1,
  REPLENISH_ORDER: 2,
};
